export default {
	"cityPlan": {
		"autoRouteAdd": "自动追加",
		"downExcleRouterList": "导出运单",
		"revokeOrder": "撤销审核",
		"importExcleLine": "导入排线",
		"planInMap": "在图调整",
		"lineMeasure": "线路测算",
		"importTips3": "导入排线 + 调度信息 + 直接调度",
		"info": "信息",
		"autoLineResultTitle": "自动线路规划结果",
		"sucRoute": "成功运单",
		"errRoute": "失败运单",
		"onTimeRoute": "准时",
		"totalKm": "总里程",
		"generalCargo": "总货量",
		"sectionsRoute": "中转分段",
		"splitGoods": "货量拆分",
		"revokeSections": "撤销分段",
		"revokeSplit": "撤销拆分",
		"modifyTime": "修改时间",
		"detailSplit": "明细拆分",
		"transitInformation": "中转信息",
		"transportSplit": "运单拆分",
		"oldTransportWeight": "原重量(千克)",
		"splitWeight": "拆出重量(千克)",
		"oldTransportVolume": "原体积(方)",
		"splitVolume": "拆出体积(方)",
		"originalDeclaredPrice": "原声明价格",
		"splitOriginalDeclaredPrice": "拆出声明价格",
		"receiptQty": "原回单份数",
		"splitReceiptQty": "拆出回单份数",
		"packingQty": "原包装数",
		"splitPackingQty": "拆出原包装数",
		"goodsQty": "原货品量",
		"splitGoodsQty": "拆出货品量",
		"Tips1": "填写重量时会自动按比例生成其他的拆出量",
		"Tips2": "拆出重量必须大于0或者小于原重量",
		"Tips3": "拆出体积必须大于0或者小于原体积",
		"Tips4": "拆出声明价格必须大于等于0或者小于等于原价格声明",
		"Tips5": "包装数为1不能进行拆单",
		"Tips6": "货品量为1不能进行拆单"
	},
	"planlookCity": {
		"planlookcityTransitTitle": "运单中转站点设置",
		"planlookcitySplitDetailTitle": "单据拆分明细"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/cityPlan/cityPlan.js